import { PathOptions } from "leaflet";

export const estado_pe = (feature: any): PathOptions => {
  return {
    color: "#3155A4",
    weight: 3,
    opacity: 1,
    fillColor: "transparent",
    fillOpacity: 0,
  };
};
